import React, { Component } from 'react';
import clsx from 'clsx';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Switch, Route, withRouter } from "react-router-dom";

// Material Components
import AppBar from '@material-ui/core/AppBar';

import { ButtonGroup } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Icon from '@material-ui/core/Icon';
import Link from '@material-ui/core/Link';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AppWrapper from '../containers/wrapper';

//Components
import Banner from './banner_component.js';

// Our Components
import APIStepper from './APIStepper';

// Logo
import { ReactComponent as LogoSVG } from '../images/logo.svg';

import '../styles/App.css';

const theme = createMuiTheme({
  overrides: {

  },
});
const styles = theme => ({
  root: {
    display: 'flex',
    paddingLeft: '80px',
    paddingRight: '80px'
  },
  hide: {
    display: 'none',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    fontFamily: 'Roboto'
  },
  buttonGroup: {
    margin: 'auto',
  }
});


class App extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    const { classes } = this.props;
    let props = {name: "Snippext Demo", pub_ancor: "https://dl.acm.org/doi/abs/10.1145/3366423.3380144", blog_link: "https://megagon.ai/blog/snippext-better-opinion-mining-with-less-training-data/"}

    return (
      <ThemeProvider theme={theme}>
      <AppWrapper props={props}>
        <div className={classes.root}>
          <CssBaseline />
          <main className={classes.content}>
              <Switch>
                <Route exact path="/">
                  <APIStepper />
                </Route>
              </Switch>

          </main>
        </div>
      </AppWrapper>
      </ThemeProvider>
    );
  }
}

export default withStyles(styles)(withRouter(App));
